"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
function getFolderFromRawId(rawIdentity) {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    var rawIdPath = rawIdentity.split(':\\')[1];
    var folders = store_1.default.dropdownFolders;
    for (var _i = 0, folders_1 = folders; _i < folders_1.length; _i++) {
        var folder = folders_1[_i];
        if (rawIdPath === folder.path) {
            return folder;
        }
    }
    return null;
}
exports.getFolderFromRawId = getFolderFromRawId;
function getFolderFromFolderId(folderId) {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    var folders = store_1.default.dropdownFolders;
    for (var _i = 0, folders_2 = folders; _i < folders_2.length; _i++) {
        var folder = folders_2[_i];
        if (folderId === folder.folderId) {
            // when we call this function from the create rule dialog the rawIdentity uses the folderId from the mail store
            return folder;
        }
    }
    return null;
}
exports.getFolderFromFolderId = getFolderFromFolderId;
//# sourceMappingURL=folderTypeConversionUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/folderTypeConversionUtil.js
// module id = 3177
// module chunks = 2 90